import useTranslation from '~/hooks/useTranslation';
import summaryPromoCodeStyles from '~/styles/bookingFlow/summary-promo-code.module.css';

type Props = {
  promoCode: string;
};

export default function SummaryPromoCode({
  promoCode,
}: Props) {
  const translate = useTranslation();

  return (
    <div>
      <h2 className={summaryPromoCodeStyles.heading}>
        {translate('bookingFlow.information.promo_code')}
      </h2>

      {promoCode}

      <div className={summaryPromoCodeStyles.success}>
        {translate('bookingFlow.information.promo_code_success')}
      </div>
    </div>
  );
}
